export default () => {

  if ($('.product__tabs-for').length) {
    $('.product__tabs-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      asNavFor: '.product__tabs-nav',
    });
    $('.product__tabs-nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.product__tabs-for',
      focusOnSelect: true,
      variableWidth: true,
      swipeToSlide: true,
      prevArrow: '<span class="slick-prev"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      nextArrow: '<span class="slick-next"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            arrows: false
          }
        }
      ]
    });
  }

  if ($('.product__for').length) {
    $('.product__for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<span class="slick-prev"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      nextArrow: '<span class="slick-next"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      fade: true,
      asNavFor: '.product__nav',
    });
    $('.product__nav').slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: '.product__for',
      arrows: false,
      focusOnSelect: true,
      swipeToSlide: true
    });
  }

  if ($('.vacancy__slider').length) {
    $('.vacancy__slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });
    $('.vacancy__slider-item-prev').on('click', () => {
      $('.vacancy__slider').slick('slickPrev');
    })
    $('.vacancy__slider-item-next').on('click', () => {
      $('.vacancy__slider').slick('slickNext');
    })
  }

  if ($('.partners__slider').length) {
    $('.partners__slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<span class="slick-prev"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      nextArrow: '<span class="slick-next"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      dots: true,
      responsive: [
        {
          breakpoint: 1439,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
            arrows: false
          }
        }
      ]
    });
  }

  if ($('.brands__list').length) {
    $('.brands__list').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      prevArrow: '<span class="slick-prev"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      nextArrow: '<span class="slick-next"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      dots: true,
      responsive: [
        {
          breakpoint: 1366,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }

  if ($('.main-slider').length) {
    $('.main-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<span class="slick-prev"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      nextArrow: '<span class="slick-next"><svg width="9" height="15" viewBox="0 0 9 15" xmlns="http://www.w3.org/2000/svg"><path d="M7.2973 15L9 13.25L3.40541 7.5L9 1.75L7.2973 -1.48855e-07L6.55671e-07 7.5L7.2973 15Z" /></svg></span>',
      dots: true,
      fade: true,
      asNavFor: '.main-slider-nav',
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            dots: false
          }
        }
      ]
    });
    $('.main-slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.main-slider',
      arrows: false,
      focusOnSelect: true,
      swipeToSlide: true
    });
  }

}



// WEBPACK FOOTER //
// app/scripts/components/sliders.js